import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import withModal from '../../../../../../../components/global/modal/withModal';
import Button from '../../../../../../../components/global/Button';
import Alert from '../../../../../../../components/global/Alert';
import FormGroup from '../../../../../../../components/global/FormGroup';
import { isValidEmail } from '../../../../../../../util/email';

export const DOWNLOADS_CONFIGURATOR_EMAIL_MODAL =
  'MODAL/DOWNLOADS_CONFIGURATOR_EMAIL';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  downloadsCount: PropTypes.number,
  onClose: PropTypes.func.isRequired,
};

const DownloadsConfiguratorEmailModal = ({
  onSubmit,
  downloadsCount,
  onClose,
}) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [error, setError] = useState('');

  const onFormSubmit = () => {
    if (!isValidEmail(emailAddress)) {
      setError('Please enter a valid email address.');
      return;
    }

    onSubmit?.(emailAddress);
    onClose?.();
  };

  return (
    <Fragment>
      <div>
        <h3 className="text-center">One last step!</h3>
        <p className="text-light text-center">
          Please add your email address below and we&apos;ll email your digital{' '}
          {pluralize('download', downloadsCount ?? 1)} to you!
        </p>
        <FormGroup
          type="text"
          id="email-address"
          label="Email Address"
          name="emailAddress"
          value={emailAddress}
          onChange={({ target }) => setEmailAddress(target.value)}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.stopPropagation();
              event.preventDefault();
              onFormSubmit();
            }
          }}
          required
        />
        {error && (
          <Alert
            dismissible
            type="danger"
            className="mb-2"
            onDismiss={() => setError('')}
          >
            {error}
          </Alert>
        )}
        <div className="mx-4">
          <Button btnBlock onClick={() => onFormSubmit()}>
            Submit
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

DownloadsConfiguratorEmailModal.propTypes = propTypes;

export default withModal(DownloadsConfiguratorEmailModal, {
  name: DOWNLOADS_CONFIGURATOR_EMAIL_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
  closeOnOverlayClick: false,
  className: 'downloads-configurator-email-modal',
  overlayClassName: 'downloads-configurator-email-modal-overlay',
});
